import UserCoursePage from 'Views/Courses/UserCoursePage';

export function HomeDasboard() {
  return <UserCoursePage />;
}
